import React from "react";
import { Modal } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Spinner from "@/views/components/Spinner/Spinner";

const ModalWrapperChildren = ({
	modalVisible = false,
	withFooter = true,
	setModalVisible,
	title,
	description,
	closeButtonName,
	onClose,
	confirmButtonName,
	confirmButtonName2,
	onConfirm,
	onConfirm2,
	children,
	requiredFields = false,
	disabled = false,
	requestIsPending = false,
	isLine = false,
	preTitle = false,
}) => {

	const { dict } = useSelector((state) => state.app);

	const onCloseModal = () => {
		setModalVisible(false);
	};

	return (
		<Modal
			open={ modalVisible }
			className='modal-children__wrapper'
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'
			onClose={ onClose ? onClose : onCloseModal }
		>
			<div className="modal-children__content">
				{requestIsPending && (
					<div className="letter__edit-metadata--spinner">
						<Spinner />
					</div>
				)}
				<div className="modal-children__title-container">
					{preTitle  && <>
						<p className="modal-children__preTitle">{preTitle}</p> 
						<div className="modal-children__divider" />
					</> }
					{title &&
                    <h3 className="modal-children__title">{title}</h3>
					}
				</div>
				{description &&
                    <p className="modal-children__desc">{description}</p>
				}
				{requiredFields && <p className="modal-children__required">{dict.required}</p>}
				{children && children}
				{isLine && <hr className="modal-children__line"/>}
				{withFooter &&
					
					<div className="modal-children__buttons">
						{closeButtonName && (
							<button className="button__std"
								onClick={ onClose ? onClose : onCloseModal }>
								{closeButtonName}
							</button>
						)}
						{confirmButtonName && (
							<button
								className={ `button__blue ${disabled ? "disabled" : ''}` }
								onClick={ onConfirm }
								disabled={ disabled }
							>
								{confirmButtonName}
							</button>
						)}
						{confirmButtonName2 && (
							<button
								className={ `button__blue ${disabled ? "disabled" : ''}` }
								onClick={ onConfirm2 }
								disabled={ disabled }
							>
								{confirmButtonName2}
							</button>
						)}

					</div>
				}
			</div>
		</Modal >
	);
};

ModalWrapperChildren.propTypes = {
	modalVisible: PropTypes.bool,
	setModalVisible: PropTypes.func,
	title: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.string,
	]),
	withFooter: PropTypes.bool,
	withClose: PropTypes.bool,
	closeButtonName: PropTypes.string,
	onClose: PropTypes.func,

	confirmButtonName: PropTypes.string,
	onConfirm: PropTypes.func,

	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.element,
		PropTypes.func,
	]),
};

export default ModalWrapperChildren;